import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export const MediaItemDescription = ({ description, classes }) => {
    if (!description)
        return null;
    const formatDescription = (description) => {
        return description.split("\n").map((line, idx) => (_jsxs(React.Fragment, { children: [line, idx !== description.split("\n").length - 1 && _jsx("br", {})] }, idx)));
    };
    return _jsx("div", { className: classes, children: formatDescription(description) });
};
